// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__GBNWB","fullView":"styles_fullView__1RtVH"};